import { useState, useCallback } from 'react';

/**
 * Hook for search and filter functionality
 */
export function useSearch() {
  const [searchTerm, setSearchTerm] = useState('');
  const [filters, setFilters] = useState({
    priority: '',
    sortBy: 'created_at',
    sortOrder: 'DESC'
  });

  // Update search term
  const updateSearch = useCallback((term) => {
    setSearchTerm(term);
  }, []);

  // Update filter
  const updateFilter = useCallback((key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  }, []);

  // Update sort
  const updateSort = useCallback((sortBy, sortOrder = 'DESC') => {
    setFilters(prev => ({
      ...prev,
      sortBy,
      sortOrder
    }));
  }, []);

  // Clear all filters
  const clearFilters = useCallback(() => {
    setSearchTerm('');
    setFilters({
      priority: '',
      sortBy: 'created_at',
      sortOrder: 'DESC'
    });
  }, []);

  // Build query params for API
  const getQueryParams = useCallback(() => {
    const params = {};

    if (searchTerm) {
      params.search = searchTerm;
    }

    if (filters.priority) {
      params.priority = filters.priority;
    }

    if (filters.sortBy) {
      params.orderby = filters.sortBy;
      params.order = filters.sortOrder;
    }

    return params;
  }, [searchTerm, filters]);

  return {
    searchTerm,
    filters,
    updateSearch,
    updateFilter,
    updateSort,
    clearFilters,
    getQueryParams
  };
}
